import { render, staticRenderFns } from "./ChartTimeframeSelector.vue?vue&type=template&id=1ef173ea&scoped=true&"
import script from "./ChartTimeframeSelector.vue?vue&type=script&lang=js&"
export * from "./ChartTimeframeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChartTimeframeSelector.vue?vue&type=style&index=0&id=1ef173ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef173ea",
  null
  
)

export default component.exports